import axios from "@/plugins/axios";
import inquiries from "./inquiries";

let url = "/api/console/estimate/";

export default {
    inquiries,

    getEstimates(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    getEstimate(data) {
        return axios.get(`${url}/${data._id}`, data).then((result) => result.data);
    },
    postEstimate(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    putEstimate(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    deleteEstimate(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },

    postFile(_estimate, file) {
        var data = new FormData();
        data.append("file", file);
        var headers = { "Content-Type": "multipart/formdata" };
        return axios.post(`${url}/${_estimate}/file`, data, { headers });
    },
};
